
















































































































































































































































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { RichiestaAlternanza } from "../../_models/RichiestaAlternanza";
import * as user from "../../_store/user.module";
import { bus } from "../../main";
import { userUtils } from "@/_utils";
import CreateDialog from "../Dialogs/CreateDialog.vue"

@Component({
  components: {
    CreateDialog
  }
})
export default class DetailsInfoRichiestaAlternanza extends Vue {
  @Prop() info!: RichiestaAlternanza;

  private userInfo: any;
  private createDialogParams: any;
  private showCreateDialog: boolean;

  constructor(){
    super()
    this.userInfo = {}
    this.createDialogParams = {
      visible: true,
      type: "nuovaIspezione"
    };
    this.showCreateDialog = true;
  }

  accept(){
    let idRichiesta = this.info.idRichiesta
    user.dispatchAcceptRichiestaAlternanza(this["$store"], {idRichiesta}).then(() =>{
      bus.$emit(
        "successfullOperation",
        "Disponibilità accettata con successo"
      );
      bus.$emit("closeDetailsDialog");
      this.info.idStatoAccettazione = 2
    }).catch(error => {
      if (error.response.status === 403) {
        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        this["$router"].push("/login");
      } else {
        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
      }
    });
  }

  refuse(){
    let idRichiesta = this.info.idRichiesta
    let note = this.info.note
    user.dispatchRefuseRichiestaAlternaza(this["$store"], {idRichiesta, note}).then(() =>{
      bus.$emit(
        "successfullOperation",
        "Disponibilità rifiutata con successo"
      );
      bus.$emit("closeDetailsDialog");
      this.info.idStatoAccettazione = 3
    }).catch(error => {
      if (error.response.status === 403) {
        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        this["$router"].push("/login");
      } else {
        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
      }
    });
  }

  created() {
    this.userInfo = user.readUserInfo(this["$store"]);
  }

}
